(function($) {
  $.fn.savy = function(order,fn) {
    const sv = "savy-";
    if (order == "load") {
      $(this).each(function() {
        if ($(this).is(":radio")) {
          if(localStorage.getItem(sv+$(this).attr("name"))){
            if (localStorage.getItem(sv+$(this).attr("name")) == this.id) {
              this.checked = true;
            }else{
              this.checked = false
            }
          }
          $(this).change(function() {
            localStorage.setItem(sv+$(this).attr("name"), this.id);
          });
        }else if($(this).is(":checkbox")){
          if(localStorage.getItem(sv+this.id)){
            this.checked = (localStorage.getItem(sv+this.id) == "1" ? true : false);
          }
          $(this).change(function() {
            localStorage.setItem(sv+this.id, (this.checked ? "1" : "0"));
          });
        }else if($(this).is("input") || $(this).is("textarea")) {
          if(localStorage.getItem(sv+this.id)){
            this.value = localStorage.getItem(sv+this.id);
          }
          $(this).on( 'focus', function(){
            var intervalDuration = 500,
                interval = setInterval( () => {
                  localStorage.setItem(sv+this.id, this.value);
                  if(!$(this).is(":focus")) clearInterval(interval);  
                }, intervalDuration );
          } );
        }else if($(this).is("select")) {
          if ($(this).is("[multiple]")) {
            if(localStorage.getItem(sv+this.id)){
              $(this).val(localStorage.getItem(sv+this.id).split(","));
            }else{
              localStorage.setItem(sv+this.id, $(this).val());
            }
            $(this).change(function() {
              localStorage.setItem(sv+this.id, $(this).val());
            });
          }else{
            if(localStorage.getItem(sv+this.id)){
              $(this).val(localStorage.getItem("savy-"+this.id));
            }else{
              localStorage.setItem(sv+this.id, $(this).val());
            }
            $(this).change(function() {
              localStorage.setItem(sv+this.id, $(this).val());
            });
          }
        }
      });
      if ($.isFunction(fn)){fn();}
    }else if (order == "destroy") {
      $(this).each(function() {
        if(localStorage.getItem(sv+this.id)){
          localStorage.removeItem(sv+this.id)
        }
      });
      if ($.isFunction(fn)){fn();}
    }else{
      console.error("savy action not defined please use $('.classname').savy('load') to trigger savy to save all inputs")
    }
  };
})(jQuery);

$('.auto-save').savy('load',function(){
  // console.log("All data from form save is loaded");
});

function dstry(){
  //$('.auto-save').savy('destroy') --> can be used without callback
  $('.auto-save').savy('destroy',function(){
    console.log("All data from form save is destroyed");
    window.location.reload();
  });
}

$('.cart-line-item-update').on('click', function() {
  const $this = $(this);
  const dataIndex = $this.data('index');
  var inputData = $this.closest('.propContainer').find('.propLine')
  var inputDataGift = $this.closest('.propContainer').find('.propLinegift')
  var inputDataQty = $this.closest('.propContainer').find('.propLineQty').val();
  var inputDataTypeofGift = $this.closest('.propContainer').find('.type-of-gift').val();    
  var inputDataRecipientName = $this.closest('.propContainer').find('.recipient-name').val();
  var inputDataRecipientPhoneNo = $this.closest('.propContainer').find('.recipient-phone-number').val();
  var inputDataRecipientGiftMessage = $this.closest('.propContainer').find('.recipient-gift-message').val();
  var inputDataGiftWrap = $this.closest('.propContainer').find('.gift-wrap').val();      

  var data = {
     line: dataIndex,
     properties: ''
   }
  var tempProperties = {}
  
  
    inputData.each(function(index, el) {
    tempProperties[$(el).data('name')] = $(el).val();
    tempProperties['Type of Gift'] = inputDataTypeofGift;                  
    tempProperties['Recipient'] = inputDataRecipientName;
    tempProperties['Phone Number'] = inputDataRecipientPhoneNo;
    tempProperties['Gift Message'] = inputDataRecipientGiftMessage;
    tempProperties['Gift Wrap'] = inputDataGiftWrap;
  });
  

  data.properties = tempProperties;
  
  jQuery.ajax({
    url: '/cart/change.js?quantity='+inputDataQty,
    dataType: 'json',
    data: data,
	success: function (data) {
                if (tempProperties["Product note"].length === 0) {
                     $this.closest('.propContainer').find('.saved-textarea').removeClass('visible');
                     $this.closest('.propContainer').find('.accordion').removeClass('active');
                     $this.closest('.propContainer').find('.panel').css('max-height', '');
                     $this.closest('.propContainer').find('.message').text('Product note removed.').addClass('success').fadeIn(100);                 
                     setTimeout(function() { $this.closest('.propContainer').find('.message').fadeOut(1000); }, 3000);
               } else {
      		   		  $this.closest('.propContainer').find('.message').text('Product note saved.').addClass('success').fadeIn(100);                 
                     setTimeout(function() { $this.closest('.propContainer').find('.message').fadeOut(1000); }, 3000);
//                      $this.closest('.propContainer').find('.saved-textarea').addClass('visible').html("<span class=\"strong\">Product note:<\/span> " + tempProperties["Product note"]);
                     $this.closest('.propContainer').find('.accordion').removeClass('active');
                     $this.closest('.propContainer').find('.panel').css('max-height', '');

}
        },
    
    error: function(data){
      $this.closest('.propContainer').find('.message').text('Error: Product note was not saved.').addClass('error').fadeIn(100);
    }
    
  })
.done(function() {
    window.location.reload()
  })        
      
});



var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
//       panel.style.maxHeight = panel.scrollHeight + "px";
      panel.style.maxHeight = "100%";              
    } 
  });
}

function giftoption(evt, giftchoice) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(giftchoice).style.display = "block";
  evt.currentTarget.className += " active";
}
